import { style } from '@vanilla-extract/css';
import { vars } from '../../theme/contract.css';
import { reducedMotion, mobile } from '../../theme/media';
import { fadeIn } from '../../keyframes/shared.css';
import { stateColorTokens } from '../../tokens';

export const container = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100dvh',
  padding: '32px',
  background: vars.surface.background.primary,
  animation: `${fadeIn} ${vars.animation.duration.normal} ${vars.animation.easing.easeOut}`,
  '@media': {
    [reducedMotion]: {
      animation: 'none',
    },
    [mobile]: {
      padding: '24px',
    },
  },
});

export const content = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '24px',
  maxWidth: '500px',
  textAlign: 'center',
});

export const iconWrapper = style({
  width: '80px',
  height: '80px',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: stateColorTokens.error.popoverHoverBg,
  border: `2px solid ${vars.bright.status.error}`,
  boxShadow: vars.bright.glow.red,
  '@media': {
    [mobile]: {
      width: '64px',
      height: '64px',
    },
  },
});

export const icon = style({
  fontSize: vars.typography.fontSize['4xl'],
  color: vars.bright.status.error,
  '@media': {
    [mobile]: {
      fontSize: vars.typography.fontSize['3xl'],
    },
  },
});

export const title = style({
  fontSize: vars.typography.fontSize['2xl'],
  fontWeight: vars.typography.fontWeight.bold,
  color: vars.bright.status.error,
  margin: 0,
  fontFamily: vars.typography.fontFamily.primary,
  '@media': {
    [mobile]: {
      fontSize: vars.typography.fontSize.xl,
    },
  },
});

export const description = style({
  fontSize: vars.typography.fontSize.base,
  color: vars.typography.textColor.secondary,
  lineHeight: vars.typography.lineHeight.relaxed,
  margin: 0,
  fontFamily: vars.typography.fontFamily.primary,
  '@media': {
    [mobile]: {
      fontSize: vars.typography.fontSize.sm,
    },
  },
});

export const errorDetails = style({
  marginTop: '16px',
  padding: '16px',
  background: vars.surface.background.glass,
  border: `1px solid ${vars.surface.border.secondary}`,
  borderRadius: '8px',
  maxWidth: '100%',
  overflow: 'auto',
});

export const errorMessage = style({
  fontSize: vars.typography.fontSize.sm,
  color: vars.typography.textColor.tertiary,
  fontFamily: vars.typography.fontFamily.mono,
  textAlign: 'left',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
  margin: 0,
});

export const retryButton = style({
  marginTop: '8px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  padding: '12px 24px',
  borderRadius: '6px',
  fontFamily: vars.typography.fontFamily.primary,
  fontSize: vars.typography.fontSize.base,
  fontWeight: vars.typography.fontWeight.semibold,
  cursor: 'pointer',
  transition: `background ${vars.animation.duration.fast} ${vars.animation.easing.easeOut}, box-shadow ${vars.animation.duration.fast} ${vars.animation.easing.easeOut}, transform ${vars.animation.duration.fast} ${vars.animation.easing.easeOut}`,
  border: 'none',
  outline: 'none',
  background: vars.button.primary.background,
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: vars.surface.border.glow,
  color: vars.typography.textColor.inverse,
  boxShadow: vars.bright.glow.primary,
  selectors: {
    '&:hover': {
      background: vars.button.primary.hoverGradient,
      boxShadow: `${vars.bright.glow.primary}, 0 2px 10px ${vars.surface.highlight.strong}`,
      transform: 'translateY(-1px)',
    },
  },
  '@media': {
    [reducedMotion]: {
      transition: 'none',
    },
    [mobile]: {
      padding: '10px 20px',
      fontSize: vars.typography.fontSize.sm,
    },
  },
});
